import Vue from 'vue'
import PPVueLibrary from 'pp-vue-library'

Vue.use(PPVueLibrary)
